/**
 * What this product is allowed to count.
 *
 * A closed union, and that is the whole design. An analytics layer that takes a string and a bag
 * of properties is one where the next person adds `{ mapTitle }` to a payload because it was
 * convenient, and nothing in the type system says no. Every event here is a *name* and a small
 * set of numbers whose meaning is written down beside it; there is nowhere to put a sentence.
 *
 * The list is the activation funnel and the two things that decide whether the product is
 * working — how fast it is, and how often it fails. §11's rule about never logging content is a
 * rule about analytics first: the thing a mind map tool is most tempted to measure is what people
 * write in it, and that is exactly what it must never keep.
 *
 * **Names are past tense and describe what a person did**, not what the code did. `map-created`
 * rather than `create_map_handler_called`: a funnel is a story about somebody, and an event named
 * after a function stops being readable the moment the function is renamed.
 */
/**
 * Every event name this build can send.
 *
 * Exported so the Worker that receives them can refuse anything else. A boundary that accepted an
 * arbitrary string would be a boundary a future bug could put a map title through.
 */
export const FUNNEL_EVENTS = [
    'app-opened',
    'map-created',
    'map-edited',
    'signed-in',
    'map-synced',
    'draft-previewed',
    'draft-accepted',
    'draft-discarded',
    'map-exported',
];
export const TIMING_EVENTS = ['map-opened', 'draft-generated', 'sync-push'];
/** The largest timing this product will record. Past it, something hung rather than took time. */
export const MAX_TIMING_MS = 5 * 60_000;
//# sourceMappingURL=events.js.map